import { StarsButton, Translation } from '@ps/web-shared-components';
import classNames from 'clsx';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';

import { select } from '@swf/core/store';
import { DropdownMenu, useCheckUserClubRole } from '@swf/poker';

import { ClubRoute, UserClubRole } from '../../../../types/common';
import type { MenuOption } from '../../../DropdownMenu/DropdownMenu';
import LeaveClubButton from '../LeaveClubButton/LeaveClubButton';
import MenuIcon from '../assets/menu.svg';

import {
  TXTCLI_Please_use_our_customer_suppor_ELL,
  TXTCLI_Report_Club,
  TXTCLI_Settings
} from './SettingsButton.messages.json';
import styles from './SettingsButton.scss';

export interface Props {
  onSelect: (option: MenuOption) => void;
}

const SettingsButton: React.FC<Props> = ({ onSelect }) => {
  const isMobile = useSelector(select.device.isMobile);
  const { clubId } = useParams<{ clubId: string }>();
  const canLeave = useCheckUserClubRole(clubId, [UserClubRole.Admin, UserClubRole.Member]);

  const options = useMemo(() => {
    const options: MenuOption[] = [
      {
        text: (
          <div>
            <Translation {...TXTCLI_Settings} />
          </div>
        ),
        value: ClubRoute.Settings
      },
      {
        text: (
          <div>
            <p className={styles.reportClub}>
              <Translation {...TXTCLI_Report_Club} />
            </p>
            <p className={styles.reportClubInfo}>
              <Translation {...TXTCLI_Please_use_our_customer_suppor_ELL} />
            </p>
          </div>
        ),
        value: ClubRoute.ReportClub
      }
    ];

    if (canLeave) {
      return [
        ...options,
        {
          text: <LeaveClubButton />,
          data: {
            skipClose: true
          }
        }
      ];
    }

    return options;
  }, [canLeave]);

  return (
    <DropdownMenu
      onSelect={onSelect}
      options={options}
      containerClassName={isMobile ? styles.mobileButton : ''}
      menuClassName={isMobile ? styles.mobileMenu : styles.menu}
      arrowClassName={styles.arrow}
      placement="bottom-end"
    >
      <StarsButton
        data-testid="settings-button"
        variant="text"
        className={classNames(styles.button)}
        icon={<MenuIcon className={styles.icon} />}
      />
    </DropdownMenu>
  );
};

export default SettingsButton;
